<template>
  <div>
    <a-menu v-model="current" mode="horizontal">
      <a-menu-item key="user" @click="goTo('user')">
        <a-icon type="double-left" style="margin-right: 5px;" />
        Danh sách
      </a-menu-item>
      <a-menu-item key="basicInfoUser" @click="goTo('basicInfoUser')">
        Thông tin chung
      </a-menu-item>
    </a-menu>
  </div>
</template>
<script>
export default {
  data() {
    return {
      current: ["Thông tin chung"],
    };
  },
  methods: {
    goTo(name) {
      this.$router.push({ name });
    },
    checkCurrentActive() {
      const pathName = this.$route.name;
      if (pathName) {
        this.current = [pathName];
      }
    },
  },
  created() {
    this.checkCurrentActive();
  },
};
</script>
